import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotSection from "./components/HotSection";
import NewSection from "./components/NewSection";
import CompletedSection from "./components/CompletedSection";
import FAQSection from "./components/FAQSection";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { faqData } from "@/mocks/aboutData";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "韩漫在线免费看-韩漫免费漫画在线观看下拉式免费阅读-虚空韩漫网",
            description:
              "虚空韩漫网提供独特的韩漫在线免费看体验，韩漫免费漫画在线观看采用下拉式免费阅读，带给您新颖的阅读感受。",
            url: "https://xukongmanhua.com",
            isPartOf: {
              "@type": "WebSite",
              name: "虚空韩漫网",
              url: "https://xukongmanhua.com",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqData.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotSection />
        <NewSection />
        <CompletedSection />
        <FAQSection />
      </main>
    </>
  );
}